import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { PaymentMethodModel } from '@data-layer/models/payments';

@Component({
  selector: 'app-payment-methods-card',
  templateUrl: './payment-methods-card.component.html',
  styleUrls: ['./payment-methods-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodsCardComponent {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public paymentMethods: PaymentMethodModel[] = [];
  @Input() public isShowFee: boolean;
  @Input() public isSkipHints: boolean;
}
